import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import { useOrg } from '@/context/OrgContext'
import type { Produk } from '@/types'

export function useSearch(q: string) {
  const { orgId } = useOrg()
  const [results, setResults] = useState<Produk[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!q.trim()) return

    setLoading(true)
    let query = supabase
      .from('produk')
      .select('*')
      .eq('aktif', true)
      .ilike('nama', `%${q}%`)
      .order('nama')

    if (orgId) query = query.eq('organization_id', orgId)

    query.then(({ data }) => {
      setResults(data ?? [])
      setLoading(false)
    })
  }, [q, orgId])

  return { results, loading }
}
